import { inject, observer } from "mobx-react";
import { FileUpload } from "primereact/fileupload";
import { useRef } from "react";

import "./style.scss";

import { useState } from "react";
import ButtonUI from "@UI/ButtonUI";

const BucketsUpload = inject("mainStore")(
    observer(({ mainStore, changeableData }) => {
        const fileInputRef = useRef(null);
        const [isFileUploaded, setIsFileUploaded] = useState(false);

        const handleUpload = async (event) => {
            const obj = { bucketCode: changeableData.code, file: event.files[0] };

            let formData = new FormData();
            Object.entries(obj).forEach((i) => {
                const [key, val] = i;
                formData.append(key, val);
            });

            const resp = await mainStore.uploadFile(`/promo/uploadpromobucketfile`, formData, false);

            if (resp && resp.success) {
                mainStore.setMainStore("detailData", {});
                event.options.clear();
                mainStore.setMainStore("toast", { severity: "success", summary: `Файлы отправлены` });
                await mainStore.putByUrl(`promo/buckets/${changeableData._id}`, { active: true, draft: false }, "detailData");
            } else {
                mainStore.setMainStore("toast", { severity: "warn", summary: `Ошибка`, detail: resp.msg || resp.code || "Проверьте файл" });
                return;
            }
        };

        const headerTemplate = (options) => {
            const { className, chooseButton, uploadButton, cancelButton } = options;

            return (
                <div className={className} style={{ backgroundColor: "#f8f9fb", display: "flex", alignItems: "center" }}>
                    {chooseButton}
                    {uploadButton}
                    {cancelButton}
                </div>
            );
        };

        // тип кнопок Для загрузки файла
        const chooseOptions = { icon: "pi pi-fw pi-plus", className: "custom-choose-btn p-button-info", disabled: isFileUploaded };
        const uploadOptions = { icon: "pi pi-fw pi-upload", className: "custom-choose-btn p-button-success" };
        const cancelOptions = { icon: "pi pi-fw pi-times", className: "custom-choose-btn p-button-danger" };

        const itemTemplate = (file, options) => {
            if (file) {
                setIsFileUploaded(true);
            }
            return (
                <div className="detail__upload">
                    <div className="name__file" style={{ width: "40%" }}>
                        <span className="text">{file.name}</span>
                        <span className="text">{options.formatSize}</span>
                    </div>
                    <ButtonUI icon="pi pi-times" rounded text severity="danger" aria-label="Cancel" onClick={() => options.onRemove()} />
                </div>
            );
        };

        return (
            <div className="buckets__upload">
                <div className="upload">
                    <div className="upload__header">
                        <div className="title">Выберите файлы для загрузки</div>
                    </div>

                    <FileUpload
                        name="demo[]"
                        url={"/api/upload"}
                        chooseLabel="Выбрать"
                        uploadLabel="Отправить"
                        cancelLabel="Удалить"
                        chooseOptions={chooseOptions}
                        uploadOptions={uploadOptions}
                        cancelOptions={cancelOptions}
                        itemTemplate={itemTemplate}
                        ref={fileInputRef}
                        maxFileSize={10000000}
                        headerTemplate={headerTemplate}
                        uploadHandler={handleUpload}
                        customUpload
                    />
                </div>
            </div>
        );
    }),
);

export default BucketsUpload;
